module.exports = __webpack_public_path__ + "static/media/move-sensor.f25f21fa.svg";